import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Ventas from "@/pages/Ventas";
import Facturas from "@/pages/Facturas";
import Proveedores from "@/pages/Proveedores";
import Revisar from "@/pages/Revisar";
import Configuracion from "@/pages/Configuracion";
import Bancos from "@/pages/Bancos";
import CuentasPagar from "@/pages/CuentasPagar";
import Conciliacion from "@/pages/Conciliacion";
import Pnl from "@/pages/Pnl";
import CashFlow from "@/pages/CashFlow";
import CortesCaja from "@/pages/CortesCaja";
import Nominas from "@/pages/Nominas";
import { Privacidad, Condiciones } from "@/pages/LegalPages";
import { Toaster } from "@/components/ui/sonner";

function Protected() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="w-10 h-10 border-2 border-[#D9381E] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // MANAGER: acceso exclusivo a Cortes de caja
  if (user.role === "MANAGER" && location.pathname !== "/cortes-caja") {
    return <Navigate to="/cortes-caja" replace />;
  }
  return <ErrorBoundary><Layout /></ErrorBoundary>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Landing />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/condiciones" element={<Condiciones />} />
          <Route element={<Protected />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/ventas" element={<Ventas />} />
            <Route path="/facturas" element={<Facturas />} />
            <Route path="/proveedores" element={<Proveedores />} />
            <Route path="/revisar" element={<Revisar />} />
            <Route path="/configuracion" element={<Configuracion />} />
            <Route path="/personal" element={<Nominas />} />
            <Route path="/cuentas-por-pagar" element={<CuentasPagar />} />
            <Route path="/bancos" element={<Bancos />} />
            <Route path="/conciliacion" element={<Conciliacion />} />
            <Route path="/pnl" element={<Pnl />} />
            <Route path="/cash-flow" element={<CashFlow />} />
            <Route path="/cortes-caja" element={<CortesCaja />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
